// services/commentService.ts
import api from "../../../../services/api";

export const commentService = {
  // Create a new comment
  createComment: async (data: {
    report_id: number;
    comment_text: string;
    parent_id?: number | null;
  }) => {
    const signature = localStorage.getItem("signature");
    return await api.post("ers/comments/create", {
      signature,
      ...data,
    });
  },

  // Update existing comment
  updateComment: async (data: { comment_id: number; comment_text: string }) => {
    const signature = localStorage.getItem("signature");
    return await api.post("ers/comments/update", {
      signature,
      ...data,
    });
  },

  // Delete comment
  deleteComment: async (comment_id: number) => {
    const signature = localStorage.getItem("signature");
    return await api.post("ers/comments/delete", {
      signature,
      comment_id,
    });
  },

  // Get comments by report
  getCommentsByReport: async (data: {
    report_id: number;
    page?: number;
    limit?: number;
  }) => {
    const signature = localStorage.getItem("signature");
    return await api.post("ers/comments/getByReport", {
      signature,
      page: data.page || 1,
      limit: data.limit || 20,
      report_id: data.report_id,
    });
  },

  // Get replies for a comment
  getRepliesByComment: async (comment_id: number) => {
    const signature = localStorage.getItem("signature");
    return await api.post("ers/comments/getReplies", {
      signature,
      comment_id,
    });
  },
};
